<template>
  <div>
      <div class="text-left mt-5">
          <b-row>
              <b-col>
                  <h5 class="text-primary">
                      <b>Message Test For Paxel Market</b>
                  </h5>
              </b-col>
          </b-row>
          <b-row class="mt-4">
              <b-col md="6" >
                  <b-card class="p-3">
                        <b-form-group id="input-group-2" label="Phone Number" label-for="input-2">
                            <b-form-input
                            id="input-2"
                            placeholder="Enter Phone Number"
                            ></b-form-input>
                        </b-form-group>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-4">
              <b-col>
                  <b-card>
                        <h6 class="text-primary">
                            <b>Pending Payment</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card class="pb-3">
                        <h6 class="text-primary">
                            <b>Processing</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card class="pb-3">
                        <h6 class="text-primary">
                            <b>Confirmation Order</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card class="pb-3">
                        <h6 class="text-primary">
                            <b>On Shipment</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card class="pb-3">
                        <h6 class="text-primary">
                            <b>Completed</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                <br>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                </b-form-group>
                                <b-form inline>
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    required
                                    class="mr-3"
                                    style="width:80%"
                                    ></b-form-select>
                                    <b-button variant="primary" style="width:17.6%">Test</b-button>
                                </b-form>
                                
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            to_seller_payment:false,
            to_buyer_payment:false,
        }
    },
}
</script>

<style>

</style>